import providerInstance from "../api-provider";
import handleError from "../handleError";

export const getDictationListBySearch = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/scribe/getDictationListBySearch",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getStatusList = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/scribe/getStatusList",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getScribeList = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/scribe/getScribeList",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};
